
import { useEffect, useState } from 'react';
import { MOBILE_CONFIG } from './constants';

// Hook for detecting mobile devices
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Set initial state based on window width
    setIsMobile(window.innerWidth < MOBILE_CONFIG.BREAKPOINT);
    
    // Use matchMedia for more efficient listening
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_CONFIG.BREAKPOINT - 1}px)`);
    
    // Create a handler for window resize events
    const handleResize = () => {
      setIsMobile(mediaQuery.matches);
    };
    
    // Add event listener using the standardized method
    mediaQuery.addEventListener('change', handleResize);
    
    // Clean up event listener on unmount
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  return isMobile;
}

// Hook for detecting device orientation
export function useDeviceOrientation() {
  const [isLandscape, setIsLandscape] = useState<boolean>(false);
  
  useEffect(() => {
    const checkOrientation = () => {
      // Use screen.orientation API if available
      if (window.screen && window.screen.orientation) {
        setIsLandscape(
          window.screen.orientation.type.includes('landscape')
        );
      } else {
        // Fallback to window dimensions
        setIsLandscape(window.innerWidth > window.innerHeight);
      }
    };
    
    // Check initial orientation
    checkOrientation();
    
    // Set up event listeners for orientation changes
    window.addEventListener('orientationchange', checkOrientation);
    window.addEventListener('resize', checkOrientation);
    
    return () => {
      window.removeEventListener('orientationchange', checkOrientation);
      window.removeEventListener('resize', checkOrientation);
    };
  }, []);
  
  return isLandscape;
}
